import { Misc } from '@/utils'

export class PostMessageProcessor {
  /**
   * @param message - Message sended to parent window
   * @param to - Destination frame of the nessage
   */
  static send(message: any, element?: HTMLIFrameElement, to?: string) {
    if (to) {
      element!.contentWindow!.postMessage(message, to)
    } else if (Misc.hasParentWindow()) {
      const parentDomain = Misc.getCurrentParentDomain()
      window.parent.postMessage(message, parentDomain)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/PostMessageProcessor.ts